import { useCallback, useState } from "react";
import { Node } from "reactflow";

export const useMissingMappingData = () => {
  const [missingNodeIds, setMissingNodeIds] = useState<string[]>([]);

  const checkForMissingMappingData = useCallback(
    (chartNodes: Node[], callBack: (errorMessages: string[]) => void) => {
      const errorMessages = [];
      for (const node of chartNodes) {
        const keys = Object.keys(node.data?.reference || {});
        if (keys.length === 0) {
          setMissingNodeIds(prev => [...new Set([...prev, node.id])]);
          errorMessages.push(`Node ${node?.data?.label} is missing mapping data.`);
        }
        if (keys.length > 0) {
          setMissingNodeIds(prev => prev.filter(id => id !== node.id));
        }
      }
      callBack(errorMessages);
    },
    []
  );

  return [missingNodeIds, setMissingNodeIds, checkForMissingMappingData] as const;
};
